import { render, staticRenderFns } from "./TestQuestionOverviewPills.vue?vue&type=template&id=bdfc6f12&scoped=true&"
import script from "./TestQuestionOverviewPills.vue?vue&type=script&lang=js&"
export * from "./TestQuestionOverviewPills.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionOverviewPills.vue?vue&type=style&index=0&id=bdfc6f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfc6f12",
  null
  
)

export default component.exports